<template>
  <li>
    <router-link active-class="" :to="{ name: 'bookings.show', params: { id: this.booking.id } }">
      <h3>{{ bookingName }}</h3>
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div :class="profileTalentBookingListItemColumns">
              <p><i class="fa fa-map-marker fa-fw"></i> {{ bookingStateOrOnline }}</p>
            </div>
            <div :class="profileTalentBookingListItemColumns">
              <p v-if="bookingAppearanceInPerson || bookingAppearanceOffer"><i class="fa fa-calendar fa-fw"></i> {{ booking.tz_date | dateTimezone(booking.timezone, $user.date_format_preference) | nullable }}</p>
              <p v-else><i class="fa fa-calendar fa-fw"></i> &ndash;</p>
            </div>
            <div :class="profileTalentBookingListItemColumns">
              <p>
                <span class="label label-danger" v-if="bookingIsContextuallyCancelled">Cancelled</span>
                <span class="label label-success" v-else-if="bookingIsScheduled">Scheduled</span>
                <span class="label label-info" v-else-if="bookingIsOnHold">On Hold</span>
                <span class="label label-success" v-else-if="bookingIsBooked">Booked</span>
                <span class="label label-info" v-else-if="bookingIsCompleted">Completed</span>
                <span class="label-hidden" v-if="$userIsAdmin && bookingIsNotPublic">Hidden</span>
                <span class="label label-danger" v-if="bookingBookedDepositUnpaid">Deposit Unpaid</span>
                <span class="label label-danger" v-if="bookingBookedDepositSent">Deposit Sent</span>
              </p>
            </div>
            <div v-if="$userIsAdmin || ($vlastMode && $isCricketAus && $userIsManager)" :class="profileTalentBookingListItemColumns">
              <p>Booking ID: {{ this.booking.id }}</p>
            </div>
          </div>
        </div>
      </div>
      <span class="price" v-if="userCanSeeBudget && !bookingAppearanceOffer">
        <template class="amount" v-if="booking.local_currency">
          {{ booking.local_currency_budget_per_star_as_user_rate | currency(booking.local_currency) | nullable }}
        </template>
        <template class="amount" v-else>
          {{ booking.budget_per_star_as_user_rate | currency(booking.currency) | nullable }}
        </template>
      </span>
    </router-link>
  </li>
</template>

<script>
import { helpers } from 'mixins/bookings'

export default {
  mixins: [helpers],

  computed: {
    profileTalentBookingListItemColumns () {
      return this.$userIsAdmin ? 'col-xs-6 col-sm-3' : 'col-xs-6 col-sm-4'
    }
  },

  props: {
    booking: {
      type: Object,
      required: true
    }
  }
}
</script>
